module.exports = __webpack_public_path__ + "img/inform.33de82d5.svg";